import { ResourceCountSummaryService } from '@/services/resource-count-summary-service';
import { onBeforeMount, ref } from 'vue';
import { useStore } from 'vuex';
import { ResourceType } from '@/services/common/enums';
import { useRouter } from 'vue-router';
import icons from '@/assets/resource-type-icons';
const service = new ResourceCountSummaryService();
export default {
    name: 'ResourceTypeSummary',
    setup() {
        const store = useStore();
        const router = useRouter();
        const summary = [
            {
                id: 'layers',
                title: 'Spatial Data Layers',
                icon: icons[ResourceType.VectorLayer].icon,
                tooltip: 'click to browse available datasets',
                type: ResourceType.VectorLayer,
            },
            {
                id: 'tables',
                title: 'Table Datasets',
                icon: 'fas fa-table-cells',
                tooltip: 'click to browse available datasets',
                type: ResourceType.Table,
            },
            {
                id: 'notebooks',
                title: 'Python Notebooks',
                icon: 'fab fa-python',
                tooltip: 'click to browse python notebooks',
                type: ResourceType.PythonNotebook,
            },
            {
                id: 'applications',
                title: 'Applications',
                icon: 'fas fa-gauge-high',
                tooltip: 'click to browse applications',
                type: ResourceType.ExternalApplication,
            },
        ];
        const counts = ref({});
        onBeforeMount(async () => {
            counts.value = await service.Get();
        });
        function setResourceType(resourceType) {
            store.dispatch('Resources/resetFilters');
            store.dispatch('Resources/setResourceType', resourceType);
            router.push('/Resources');
        }
        return { summary, counts, setResourceType };
    },
};
